import React from 'react';
import configuration from './config.js';

const Logo = () => (
	<div>
        <img  src={configuration.clientLogo + '/Logo.png'}  alt="" height="50px"  />
	</div>
);

export default  Logo ;

